/**
 * ReveiwDetailContainer
 * --
 */
import React from 'react';
import ReviewDetailPresenter from './ReviewDetailPresenter';

const ReveiwDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ReviewDetailPresenter />
    </>
  );
};

export default ReveiwDetailContainer;
